(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["caribis-light-gallery"] && !Shopify.designMode) return;
  try {
    
function initCaribisGalleries(container){container.querySelectorAll('.caribis-gallery').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const video=root.querySelector('video'),button=root.querySelector('button');function sync(){button.textContent=video.paused?button.dataset.play:button.dataset.pause;button.setAttribute('aria-label',button.textContent)}button.addEventListener('click',()=>{if(video.paused)video.play().catch(sync);else video.pause()});video.addEventListener('play',sync);video.addEventListener('pause',sync);if(!matchMedia('(prefers-reduced-motion: reduce)').matches){const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting)video.play().catch(sync);else video.pause()}),{threshold:.1});observer.observe(video)}})}
initCaribisGalleries(document);document.addEventListener('shopify:section:load',()=>initCaribisGalleries(document));

  } catch(e) { console.error(e); }
})();
})();
